import type { ExtractPropTypes } from "vue";

export const ToolSearchPropsOption = {
    width: { type: [Number, String] as PropType<number | string> },
    modelValue: { type: String, required: true },
    placeholder: { type: String },
} as const;

export type ToolSearchProps = ExtractPropTypes<typeof ToolSearchPropsOption>;

export type ToolSearchEmits = {
    (event: "search"): void;
    (event: "update:modelValue", keyword: string): void;
};
